import { render, staticRenderFns } from "./DisplayFile.vue?vue&type=template&id=2e7687f8&"
import script from "./DisplayFile.vue?vue&type=script&lang=js&"
export * from "./DisplayFile.vue?vue&type=script&lang=js&"
import style0 from "./DisplayFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports